import { addonList } from '@api/sdk.gen';

// Last resort when the list is empty or unavailable; matches the "portainer-run"
// path in addons-catalog.json.
// TODO(multi-addon): no single path to guess once there are several add-ons -
// decide what a denied user with nothing to land on should see, and drop this.
const FALLBACK_ADDON_PATH = '/addons/portainer-run/';

/**
 * Where to send a user whose team denies Portainer access. The add-on list is
 * already scoped to what the user can reach, so the target follows from access.
 */
export async function resolveLandingAddonPath() {
  try {
    const { data } = await addonList({});
    const addons = data?.addons ?? [];
    if (addons.length === 0) {
      return FALLBACK_ADDON_PATH;
    }
    // TODO(multi-addon): pick a designated default instead of the first.
    return addons[0]?.path || FALLBACK_ADDON_PATH;
  } catch {
    return FALLBACK_ADDON_PATH;
  }
}
